import UI from "../../components/ExcerciseTypes/Design/UserInterface";
import T6 from "../../components/ExcerciseTypes/TypeIn/T6";

const json = {
  1: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P61-E1",
    audio: "img/FriendsPlus/Page60/Audio/audio-e3-p60.mp3",
    video: "Videos/e3.p60.mp4",
    component: UI,
    recorder: true,
    question: [],
    titleQuestion: [{ color: "#44509f", num: "1", title: 'Listen to the story and repeat. Act.' }],
    questionImage: [
      // Row
      [
        // Column3
        { url: "img/FriendsPlus/Page60/E3/4.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh1-e3-p60.mp3", },
        { url: "img/FriendsPlus/Page60/E3/5.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh2-e3-p60.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page60/E3/6.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh3-e3-p60.mp3", },
        { url: "img/FriendsPlus/Page60/E3/7.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh4-e3-p60.mp3", },
      ],
      [
        // Column5
        { url: "img/FriendsPlus/Page60/E3/8.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh5-e3-p60.mp3", },
        { url: "img/FriendsPlus/Page60/E3/9.jpg", audioUrl: "img/FriendsPlus/Page60/Audio/hinh6-e3-p60.mp3", },
      ],
    ],
  },
  2: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P61-E2",
    audio: "img/FriendsPlus/Page61/Audio/audio-e2-p61.mp3",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [
      [
        // Column1
        { url: "img/FriendsPlus/Page61/E2/1.jpg" },
        {
          url: "img/FriendsPlus/Page61/E2/2.jpg",
          audioUrl: "img/FriendsPlus/Page61/Audio/tieude-e2-p61.mp3",
        },
        { url: "img/FriendsPlus/Page61/E2/3.jpg" },
      ],
      [{ url: "img/FriendsPlus/Page61/E2/4.jpg" }],
      [
        // Column2
        { url: "img/FriendsPlus/Page61/E2/5.jpg" },
        {
          url: "img/FriendsPlus/Page61/E2/6.jpg",
          audioUrl: "img/FriendsPlus/Page61/Audio/hinh1-e2-p61.mp3",
        },
        {
          url: "img/FriendsPlus/Page61/E2/7.jpg",
          audioUrl: "img/FriendsPlus/Page61/Audio/hinh2-e2-p61.mp3",
        },
        {
          url: "img/FriendsPlus/Page61/E2/8.jpg",
          audioUrl: "img/FriendsPlus/Page61/Audio/hinh3-e2-p61.mp3",
        },
        { url: "img/FriendsPlus/Page61/E2/9.jpg" },
      ],
    ],
  },
  3: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P61-E3",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page61/E3/1.jpg" }]],
  },
  4: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P61-E4",
    audio: "",
    video: "",
    component: T6,
    exerciseKey: "img/FriendsPlus/Page61/E4/Key/answerKey.png",
    inputSize: 200,
    checkUppercase: true,
    titleImage: "",
    titleQuestion: [{ color: "#44509f", num: "4", title: 'Look again and write.' }],
    questionImage: [],
    questions: [
      {
        title: `
          <div>
            <div>
              <img src="img/FriendsPlus/Page61/E4/1.jpg" style="width: 100%">
            </div>
            <div>
              <div><b>1</b>&ensp;What’s Joe wearing?</div>
              <div>&emsp;<u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;He’s wearing&ensp;</u> blue <u style='text-decoration-color: black;color:rgb(82,197,235)'>&ensp;jeans&ensp;</u>.</div>
            </div>
            <div>
              <div><b>2</b>&ensp;What’s Grandma wearing?</div>
              <div>&ensp;#a black#.</div>
            </div>
            <div>
              <div><b>3</b>&ensp;What’s Tim wearing?</div>
              <div>&ensp;#a red#.</div>
            </div>
            <div>
              <div><b>4</b>&ensp;What’s Milly wearing?</div>
              <div>&ensp;#black#.</div>
            </div>
          </div>
        `,
        answer: ["She's wearing", "skirt", "He's wearing", "shirt", "She's wearing", "boots"],
      },
    ],
  },
  5: {
    // Exercise num
    unit: "Unit 9",
    id: "SB3-U9-P61-E5",
    audio: "",
    video: "",
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: "img/FriendsPlus/Page61/E5/1.jpg" }]],
  },
};

export default json;
